import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'fac_requires_wkr_provide_commitments_verbally_writing_that'

export const dataPointDefinition = {
  retracedId: 'fac_requires_wkr_provide_commitments_verbally_writing_that',
  name: 'Facility requires worker to provide commitments (verbally or in writing) that they will not become pregnant',
  description:
    'Select this option if the facility requires any workers to provide commitments (verbally or in writing) that they will not become pregnant while at the facility. ',
  meta: {
    slcpMeta: {
      key: 'disc-3-3x',
      number: 'RH-DIS-5-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-3-3x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26550,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
